const images = {
  Button_Back: require('./images/Button_Back.png'),
  Button_Bible_Grey: require('./images/Button_Bible_Grey.png'),
  Button_Bible_Red: require('./images/Button_Bible_Red.png'),
  Button_Book_Grey: require('./images/Button_Book_Grey.png'),
  Button_Book_Red: require('./images/Button_Book_Red.png'),
  Button_Bookmark_Active: require('./images/Button_Bookmark_Active.png'),
  Button_Bookmark_Inactive: require('./images/Button_Bookmark_Inactive.png'),
  Button_Bookmarks: require('./images/Button_Bookmarks.png'),
  Button_Bookmarks_Grey: require('./images/Button_Bookmarks_Grey.png'),
  Button_Calendar_Grey: require('./images/Button_Calendar_Grey.png'),
  Button_Calendar_Red: require('./images/Button_Calendar_Red.png'),
  Button_Checked: require('./images/Button_Checked.png'),
  Button_Close: require('./images/Button_Close.png'),
  Button_Collapse_Grey: require('./images/Button_Collapse_Grey.png'),
  Button_Collapse_Red: require('./images/Button_Collapse_Red.png'),
  Button_Contents: require('./images/Button_Contents.png'),
  Button_Copy: require('./images/Button_Copy.png'),
  Button_Copy_Grey: require('./images/Button_Copy_Grey.png'),
  Button_Decrease: require('./images/Button_Decrease.png'),
  Button_Disclosure_Circle_Right: require('./images/Button_Disclosure_Circle_Right.png'),
  Button_Disclosure_Left: require('./images/Button_Disclosure_Left.png'),
  Button_Disclosure_Right_Black: require('./images/Button_Disclosure_Right_Black.png'),
  Button_Disclosure_Right_Grey: require('./images/Button_Disclosure_Right_Grey.png'),
  Button_Disclosure_Right_Red: require('./images/Button_Disclosure_Right_Red.png'),
  Button_Disclosure_Right_White: require('./images/Button_Disclosure_Right_White.png'),
  Button_Edit_Grey: require('./images/Button_Edit_Grey.png'),
  Button_Expand_Grey: require('./images/Button_Expand_Grey.png'),
  Button_Expand_Red: require('./images/Button_Expand_Red.png'),
  Button_Filter: require('./images/Button_Filter.png'),
  Button_Hamburger: require('./images/Button_Hamburger.png'),
  Button_Hide: require('./images/Button_Hide.png'),
  Button_Home_Grey: require('./images/Button_Home_Grey.png'),
  Button_Home_Red: require('./images/Button_Home_Red.png'),
  Button_Increase: require('./images/Button_Increase.png'),
  Button_More_Grey: require('./images/Button_More_Grey.png'),
  Button_More_Red: require('./images/Button_More_Red.png'),
  Button_Notes_Active: require('./images/Button_Notes_Active.png'),
  Button_Notes_Inactive: require('./images/Button_Notes_Inactive.png'),
  Button_Settings: require('./images/Button_Settings.png'),
  Button_Share: require('./images/Button_Share.png'),
  Button_Show: require('./images/Button_Show.png'),
  Button_Sidebar: require('./images/Button_Sidebar.png'),
  Button_Text_Options: require('./images/Button_Text_Options.png'),
  Button_This_Week: require('./images/Button_This_Week.png'),
  Button_Tick: require('./images/Button_Tick.png'),
  Button_View_Hide: require('./images/Button_View_Hide.png'),
  Button_View_Show: require('./images/Button_View_Show.png'),
  Icon_DP_Active: require('./images/Icon_DP_Active.png'),
  Icon_DP_Inactive: require('./images/Icon_DP_Inactive.png'),
  Icon_Lectionary_Active: require('./images/Icon_Lectionary_Active.png'),
  Icon_Lectionary_Inactive: require('./images/Icon_Lectionary_Inactive.png'),
  Icon_SW_Active: require('./images/Icon_SW_Active.png'),
  Icon_SW_Inactive: require('./images/Icon_SW_Inactive.png'),
  Image_Landing_Devices: require('./images/Image_Landing_Devices.png'),
  Label_App_Store: require('./images/Label_App_Store.png'),
  Label_Google_Play: require('./images/Label_Google_Play.png'),
  Menu_Banner: require('./images/Menu_Banner.png'),
  appIcon: require('./images/appIcon.png'),
};

export default images;
